import InsightsPeopleRelatedContent from './InsightsPeopleRelatedContent';

export { type InsightsPeopleRelatedContentProps } from './InsightsPeopleRelatedContent';
export default InsightsPeopleRelatedContent;
